export default (namespace) => ({
  licenceConsent: {
    id: `${namespace}.licenceConsent`,
    defaultMessage: 'conditions of the insurance',
  },
});
